<template>
  <vue-select
    :options="options"
    label="label"
    placeholder="Período"
    :value="value"
    :clearable="true"
    @input="$emit('input', $event)"
  >
    <template slot="option" slot-scope="option">
      {{ option.label }}
    </template>

    <div slot="no-options">Não há opções correspondentes</div>
  </vue-select>
</template>

<script>
export default {
  name: 'SelectMes',

  props: {
    value: {
      type: Object,
      default: null,
    },
  },

  computed: {
    options() {
      return [
        this.montarOpcao('Janeiro', [1]),
        this.montarOpcao('Fevereiro', [2]),
        this.montarOpcao('Março', [3]),
        this.montarOpcao('Abril', [4]),
        this.montarOpcao('1º Quadrimestre', [1, 2, 3, 4]),
        this.montarOpcao('Maio', [5]),
        this.montarOpcao('Junho', [6]),
        this.montarOpcao('Julho', [7]),
        this.montarOpcao('Agosto', [8]),
        this.montarOpcao('2º Quadrimestre', [5, 6, 7, 8]),
        this.montarOpcao('Setembro', [9]),
        this.montarOpcao('Outubro', [10]),
        this.montarOpcao('Novembro', [11]),
        this.montarOpcao('Dezembro', [12]),
        this.montarOpcao('3º Quadrimestre', [9, 10, 11, 12]),
      ]
    },
  },

  methods: {
    montarOpcao(label, meses) {
      return {
        label,
        value: meses,
        nu_ano: this.getAnoReferencia(meses),
      }
    },

    getAnoReferencia(meses) {
      const dataAtual = new Date()
      const mesAtual = dataAtual.getMonth() + 1
      const anoAtual = dataAtual.getFullYear()

      const primeiroMes = Math.min(...meses)

      return primeiroMes <= mesAtual ? anoAtual : anoAtual - 1
    },
  },
}
</script>
